import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Modal,
  ScrollArea,
  Text,
  UnstyledButton,
  useMantineTheme,
} from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";
import { PopupPreviewInfo } from "../types";
import { getNoticeType } from "../../../../../../../shared/constants/commonCode";
import { runtimeConfig } from "../../../../../../../shared/config/runtimeConfig";

const cloudFrontUrl = runtimeConfig.s3BucketUrl;

export default function PopupPreview(props: {
  opened: boolean;
  close: () => void;
  previewInfo: PopupPreviewInfo | null;
}) {
  const { opened, close, previewInfo } = props;
  const theme = useMantineTheme();

  return (
    <Modal
      centered
      opened={opened}
      onClose={close}
      title={`[${getNoticeType(previewInfo?.noticeCd || "")}] ${
        previewInfo?.title
      }`}
    >
      <Box>
        <ScrollArea.Autosize mah={360}>
          <Flex
            direction={
              previewInfo?.imgPosition === "top" ? "column" : "column-reverse"
            }
            gap="md"
          >
            {previewInfo?.imageSrc && (
              <Image
                src={cloudFrontUrl + "/" + previewInfo.imageSrc}
                w="100%"
                fit="contain"
              />
            )}
            <Text
              size="sm"
              style={{
                whiteSpace: "pre-wrap",
                wordBreak: "keep-all",
                overflowWrap: "break-word",
                textAlign: "center",
              }}
            >
              {previewInfo?.content}
            </Text>
          </Flex>
        </ScrollArea.Autosize>
        <Divider mt="lg" mb="sm" color="primary.0" />
        <Flex justify={previewInfo?.url ? "space-between" : "center"}>
          <UnstyledButton
            style={{
              fontSize: theme.fontSizes.xs,
              color: "var(--progix-text-secondary)",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            24시간 보지 않기
            <IconX size={16} />
          </UnstyledButton>
          {previewInfo?.url && (
            <Button
              size="sm"
              color="var(--progix-primary)"
              leftSection={<IconSearch size={16} />}
              style={{
                borderRadius: "lg",
              }}
            >
              자세히 보기
            </Button>
          )}
        </Flex>
      </Box>
    </Modal>
  );
}
